import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { eachInlineTextNode } from '@/components/block-primitives/inline-markup-extension';
import { type CitationPair, citationKey } from '../../../hooks/use-sources';
import { isSourceToken } from '../source-citation-shared';
import { contextInlineMarkup } from './context-inline-markup';

// The distinct source keys `(label, locator)` in the doc — the input to the batch source fetch. Scans
// each artifactBlock's config JSON too, not just prose, so block-embedded cites also resolve.
// Parses through the full registry, not the source kind alone: a `[S1 /a]` inside a pill label is legal
// and leftmost-wins drops it, so the source kind alone would fetch a citation that never renders.
export const collectDocCitationPairs = (doc: ProseMirrorNode): CitationPair[] => {
  const seen = new Set<string>();
  const pairs: CitationPair[] = [];
  const addFrom = (text: string) => {
    for (const { token } of contextInlineMarkup.parseTokens(text)) {
      if (!isSourceToken(token)) continue;
      const sourceLabel = `S${token.sequence}`;
      for (const locator of token.locators) {
        const key = citationKey(sourceLabel, locator);
        if (seen.has(key)) continue;
        seen.add(key);
        pairs.push({ sourceLabel, locator });
      }
    }
  };
  eachInlineTextNode(doc, addFrom);
  doc.descendants(node => {
    if (node.type.name === 'artifactBlock') addFrom(String(node.attrs.config ?? ''));
  });
  return pairs;
};
